import { Home, AboutPage } from "./pages";
import { BrowserRouter, Route, Routes } from "react-router-dom"

function Gotlim() {
return (
  <BrowserRouter>
    <Routes>
      <Route exact path="/" element={<Home />} />
      <Route path="/about" element={ <AboutPage /> } />
    </Routes>
  </BrowserRouter>
);
}

export default Gotlim;